import { render, staticRenderFns } from "./AxLogin.vue?vue&type=template&id=7b316aca&scoped=true&"
import script from "./AxLogin.vue?vue&type=script&lang=ts&"
export * from "./AxLogin.vue?vue&type=script&lang=ts&"
import style0 from "./AxLogin.vue?vue&type=style&index=0&id=7b316aca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b316aca",
  null
  
)

export default component.exports